import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "How many guests can López Hill host?",
        a: "Our main hall and outdoor patio comfortably welcome up to 100 guests for an intimate ceremony and seated reception. Smaller, more private gatherings of 20–60 are equally at home in the mosaic courtyard.",
    },
    {
        q: "Is the venue exclusive on the day of our wedding?",
        a: "Yes — every wedding receives full estate buy-out from morning through midnight. No other event will share the property with you.",
    },
    {
        q: "Do you provide catering and bar service?",
        a: "We work with a curated roster of Hill Country chefs and full-service bartenders. We will introduce you to the partners best suited to your menu and style.",
    },
    {
        q: "How do we tour the estate?",
        a: "Private tours are arranged by appointment, typically on Mondays, Tuesdays or Wednesdays. Submit an inquiry below and our team will reach out to schedule.",
    },
    {
        q: "What is the deposit and cancellation policy?",
        a: "A 30% retainer reserves your date. We will share the full agreement and a tailored proposal after a tour. We also offer date-change flexibility on a case-by-case basis.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            className="section-py container-px bg-background"
            data-testid="faq-section"
        >
            <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                <div className="lg:col-span-4">
                    <p className="overline">Frequently asked</p>
                    <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05]">
                        Honest answers, <em className="italic text-[hsl(var(--primary))]">no fine print.</em>
                    </h2>
                </div>

                <div className="lg:col-span-8">
                    <Accordion type="single" collapsible className="space-y-2">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`faq-${i}`}
                                className="border-b border-border"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="text-left font-serif text-xl sm:text-2xl font-normal py-6 hover:no-underline">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-muted-foreground text-base font-light leading-relaxed pb-8 pr-12">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
